import React from 'react';
import { 
    SparklesIcon,
    ChatBubbleLeftRightIcon,
    DocumentTextIcon,
    CurrencyDollarIcon
} from '@heroicons/react/24/outline';

const AiPricing = ({ isVisible = false, onClose = () => {} }) => {
    if (!isVisible) return null;

    const features = [
        {
            name: 'Analyse de CV',
            description: 'Analyse complète de votre CV avec score et recommandations',
            cost: 0.4,
            icon: DocumentTextIcon
        },
        {
            name: 'Assistant IA Conversationnel',
            description: 'Chat avec l\'IA pour des conseils personnalisés',
            cost: 1,
            icon: ChatBubbleLeftRightIcon
        },
        {
            name: 'Conseils Contextuels',
            description: 'Suggestions automatiques basées sur votre CV',
            cost: 0,
            icon: SparklesIcon,
            free: true
        }
    ];

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            {/* Overlay */}
            <div className="absolute inset-0 bg-black/50" onClick={onClose}></div>
            
            {/* Modal */}
            <div className="relative w-full max-w-md bg-white rounded-2xl shadow-2xl">
                {/* Header */}
                <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white p-6 rounded-t-2xl">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-3">
                            <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
                                <CurrencyDollarIcon className="w-6 h-6" />
                            </div>
                            <div>
                                <h3 className="font-semibold text-lg">Tarifs IA</h3>
                                <p className="text-sm text-blue-100">Coût des fonctionnalités IA</p>
                            </div>
                        </div>
                        <button
                            onClick={onClose}
                            className="p-2 hover:bg-white/20 rounded-full transition-colors"
                        >
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                </div>

                {/* Content */}
                <div className="p-6">
                    <div className="space-y-4">
                        {features.map((feature, index) => (
                            <div key={index} className="flex items-start gap-4 p-4 border border-gray-200 rounded-xl">
                                <div className={`w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 ${
                                    feature.free 
                                        ? 'bg-green-100 text-green-600' 
                                        : 'bg-blue-100 text-blue-600'
                                }`}>
                                    <feature.icon className="w-5 h-5" />
                                </div>
                                <div className="flex-1">
                                    <div className="flex items-center justify-between mb-1">
                                        <h4 className="font-semibold text-gray-800">{feature.name}</h4>
                                                                                 <span className={`text-sm font-medium ${
                                             feature.free 
                                                 ? 'text-green-600' 
                                                 : 'text-blue-600'
                                         }`}>
                                             {feature.free ? 'Gratuit' : `${feature.cost} crédit${feature.cost > 1 ? 's' : ''}`}
                                         </span>
                                    </div>
                                    <p className="text-sm text-gray-600">{feature.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Info */}
                    <div className="mt-6 p-4 bg-blue-50 border border-blue-200 rounded-xl">
                        <div className="flex items-start gap-3">
                            <SparklesIcon className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0" />
                            <div className="text-sm">
                                <p className="font-medium text-blue-800 mb-1">Comment ça marche ?</p>
                                                                 <p className="text-blue-700">
                                     L'analyse de CV consomme 0,40 crédit, l'assistant IA 1 crédit par message. Les conseils contextuels sont gratuits et s'affichent automatiquement.
                                 </p>
                            </div>
                        </div>
                    </div>

                    {/* CTA */}
                    <div className="mt-6">
                        <button
                            onClick={onClose}
                            className="w-full py-3 px-4 bg-gradient-to-r from-blue-600 to-purple-600 text-white font-semibold rounded-xl hover:from-blue-700 hover:to-purple-700 transition-all duration-200"
                        >
                            Compris !
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AiPricing;
